export const scrollTop = function (from = 0, to, duration = 300, endCallback) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame =
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60);
      };
  }
  const difference = Math.abs(from - to);
  const step = Math.ceil((difference / duration) * 50);

  function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    let d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }
    const doc = document.documentElement;
    doc.scrollTop = d;
    // window.scrollTo(d, 0) 这方法不生效
    window.requestAnimationFrame(() => scroll(d, end, step));
  }
  scroll(from, to, step);
};
